'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('outageService', function($q, dispatcher, scheduledOutageService, apiEndpointFactory,
  $location, otppConstants, $cookies, $state, $http) {
  let endpoint = '/members/my/outage';
  let outageTrue = $q.defer();
  let skipOutageKey = otppConstants.skipOutageKey;
  let memberLogInKey = otppConstants.tokenStorageKey;

  function dayOfWeekToInt(dayOfWeek) {
    const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const index = daysOfWeek.indexOf(dayOfWeek.toLowerCase());
    if (index === -1) {
      throw new Error('Invalid day of the week');
    }
    return index;
  }

function isInOutage(outagePeriod) {
    if (outagePeriod.enabled) {
      const now = new Date();
      const currentDay = now.getDay();
      const currentTime = now.getHours();

      const beforeEnd = (currentDay < dayOfWeekToInt(outagePeriod.endDay)) ||
        (currentDay === dayOfWeekToInt(outagePeriod.endDay) && currentTime < outagePeriod.endTime);
      const afterStart = (currentDay > dayOfWeekToInt(outagePeriod.startDay)) ||
        (currentDay === dayOfWeekToInt(outagePeriod.startDay) && currentTime >= outagePeriod.startTime);

      // Edge case for outages that wrap around the week
      if (dayOfWeekToInt(outagePeriod.startDay) > dayOfWeekToInt(outagePeriod.endDay)) {
        return beforeEnd || afterStart;
      }
      return beforeEnd && afterStart;
    }
    return false;
  }

  return {
    checkOutage: function() {
      return $http.get(endpoint).then(response => {
        let params = $location.search();

        // Check for skipoutage param in url and add a cookie to the browser if it exists
        if (params[skipOutageKey] !== undefined || params['r'] !== undefined && params['r'].includes(skipOutageKey)) {
          $cookies.put(skipOutageKey, 'true');
        }
        
        
        const outageData = response.data;
        const inOutage = isInOutage(outageData);

        if (inOutage === true && !$cookies.get(skipOutageKey)) {
          scheduledOutageService.enableOutagePeriod();
          if ($cookies.get(memberLogInKey) !== undefined) {
            $state.go('p.signout');
            $cookies.remove(memberLogInKey);
          } else {
            $state.go('home');
          }
        }
        return outageTrue.resolve();
      }, function(response) {
        return outageTrue.reject(response.status);
      });
    }
  };
});

